<template>
  <div class="markdown-container" ref="markdownContainer">
    <div v-html="renderedContent"></div>
<!--    <p class="label-text">此消息由智能客服机器人发送</p>-->
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'

export default {
  name: 'StreamMDRender',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      renderedContent: '',
      md: null
    }
  },
  created () {
    this.md = new MarkdownIt({
      html: true,
      xhtmlOut: true,
      linkify: true,
      typographer: true,
      breaks: true,
      langPrefix: 'language-'
    })
    this.renderMarkdown()
  },
  mounted () {
    this.$nextTick(() => {
      this.bindRecommendQuestionClick()
    })
  },
  watch: {
    content: {
      handler (newVal) {
        this.renderMarkdown()
        this.$nextTick(() => {
          this.bindRecommendQuestionClick()
        })
      },
      immediate: true
    }
  },
  methods: {
    renderMarkdown () {
      if (this.md && this.content) {
        this.renderedContent = this.md.render(this.content)
      }
    },
    bindRecommendQuestionClick () {
      const container = this.$refs.markdownContainer
      if (!container) return

      const recommendSection = this.findRecommendQuestionSection(container)
      if (!recommendSection) return

      // 添加推荐问题类名，用于 CSS 样式控制
      recommendSection.classList.add('recommend-questions')

      // 设置【推荐问题】标题的颜色
      const prevElement = recommendSection.previousElementSibling
      if (prevElement && (prevElement.textContent.includes('推荐问题') || prevElement.textContent.includes('【推荐问题】'))) {
        prevElement.style.setProperty('color', '#1565c0', 'important')
        // 同时设置标题内部所有子元素的颜色
        const titleChildElements = prevElement.querySelectorAll('*')
        titleChildElements.forEach(child => {
          child.style.setProperty('color', '#1565c0', 'important')
        })
      }

      const listItems = recommendSection.querySelectorAll('li')
      listItems.forEach(li => {
        li.style.cursor = 'pointer'
        // 设置 li 本身的颜色
        li.style.setProperty('color', '#1565c0', 'important')
        li.style.transition = 'color 0.2s'

        // 设置 li 内部所有子元素的颜色，覆盖可能存在的内联样式
        const childElements = li.querySelectorAll('*')
        childElements.forEach(child => {
          child.style.setProperty('color', '#1565c0', 'important')
        })

        li.addEventListener('click', (e) => {
          e.stopPropagation()
          const questionText = this.extractQuestionText(li)
          if (questionText) {
            this.$emit('question-click', questionText)
          }
        })
        li.addEventListener('mouseenter', () => {
          li.style.setProperty('color', '#0d47a1', 'important')
          // 悬停时也更新内部子元素颜色
          childElements.forEach(child => {
            child.style.setProperty('color', '#0d47a1', 'important')
          })
          li.style.textDecoration = 'underline'
        })
        li.addEventListener('mouseleave', () => {
          li.style.setProperty('color', '#1565c0', 'important')
          // 恢复内部子元素颜色
          childElements.forEach(child => {
            child.style.setProperty('color', '#1565c0', 'important')
          })
          li.style.textDecoration = 'none'
        })
      })
    },
    findRecommendQuestionSection (container) {
      // 首先尝试通过查找【推荐问题】后面的列表
      const allElements = container.querySelectorAll('*')
      for (let el of allElements) {
        // 跳过 ul/ol 内部的元素，避免重复处理
        if (el.closest('ul') || el.closest('ol')) continue

        const text = el.textContent || ''
        if (text.includes('推荐问题') || text.includes('【推荐问题】')) {
          // 优先查找下一个兄弟元素是否是 ul/ol
          let sibling = el.nextElementSibling
          while (sibling) {
            if (sibling.tagName === 'UL' || sibling.tagName === 'OL') {
              return sibling
            }
            sibling = sibling.nextElementSibling
          }

          // 如果在父元素范围内查找
          let parent = el.parentElement
          if (parent && parent !== container) {
            let parentSibling = el.nextElementSibling
            while (parentSibling) {
              if (parentSibling.tagName === 'UL' || parentSibling.tagName === 'OL') {
                return parentSibling
              }
              parentSibling = parentSibling.nextElementSibling
            }
          }
        }
      }

      // 备用方案：遍历所有 ul/ol，检查其前面的文本是否包含【推荐问题】
      const uls = container.querySelectorAll('ul, ol')
      for (let ul of uls) {
        if (ul.querySelectorAll('li').length > 0) {
          const prevText = this.getPreviousSiblingText(ul)
          if (prevText && (prevText.includes('推荐问题') || prevText.includes('【推荐问题】'))) {
            return ul
          }
        }
      }
      return null
    },
    getPreviousSiblingText (el) {
      let sibling = el.previousElementSibling
      while (sibling) {
        if (sibling.textContent && sibling.textContent.trim()) {
          return sibling.textContent
        }
        sibling = sibling.previousElementSibling
      }
      return ''
    },
    extractQuestionText (li) {
      let text = li.textContent || ''
      text = text.replace(/^\d+\.\s*/, '').replace(/^[①②③④⑤⑥⑦⑧⑨⑩]+\s*/, '')
      return text.trim()
    }
  }
}
</script>

<style scoped>
.label-text {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: rgba(132, 126, 126, 1)
}

.markdown-container {
  width: 100%;
  line-height: 12px;
  color: rgb(64 64 64);
}

/* 第一个 p 标签的上边距设置为0 */
/deep/ .markdown-container > p:first-child,
/deep/ p:first-child {
  margin-top: 0;
}

/* Markdown 转换为 HTML 的样式 */

/* 修复标题选择器 - 使用逗号分隔多个选择器 */
/deep/ h1, /deep/ h2, /deep/ h3, /deep/ h4, /deep/ h5, /deep/ h6 {
  font-weight: 600;
  margin: calc(1.143 * 16px) 0 calc(1.143 * 12px) 0;
}

/deep/ h1 {
  font-size: 14px;
  margin-top: 1.2em;
  margin-bottom: 0.7em;
  line-height: 1.5;
}

/deep/ h2 {
  font-size: 14px;
  margin-top: 1.1em;
  margin-bottom: 0.6em;
  line-height: 1.5;
}

/deep/ h3 {
  font-size: 14px;
  line-height: 1.5;
}

/deep/ p {
  line-height: 1.4;
  //margin: calc(1.143 * 12px) 0;
  font-size: 13px;
}

/deep/ ul {
  list-style: disc !important; /* 实心圆点 */
  margin-top: 0.6em;
  margin-bottom: 0.9em;
  padding-left: 2em;
}

/deep/ ol {
  list-style: decimal !important;
  margin-top: 0.6em;
  margin-bottom: 0.5em;
  padding-left: 2em;
}

/* 列表项样式 */
/deep/ li {
  margin-bottom: 0.1em;
  line-height: 1.2;
}

/* 修复列表标记样式 */
/deep/ ol li::marker {
  line-height: calc(1.143 * 25px);
  color: rgb(139 139 139);
}

/deep/ ul li::marker {
  color: rgb(139 139 139);
}

/* 嵌套列表样式 */
/deep/ ul ul {
  list-style: circle;
  margin-top: 0.3em;
  margin-bottom: 0.3em;
}

/deep/ ul ul ul {
  list-style: square; /* 三级列表使用方块 */
}

/deep/ pre {
  background-color: #f5f5f5;
  padding: 1em;
  border-radius: 5px;
  overflow-x: auto;
  margin: 1em 0;
  max-width: 100%; /* 确保不超过容器宽度 */
  white-space: pre; /* 保持原始格式 */
  word-wrap: normal; /* 不在单词内部换行 */
}

/* 单独的 code 标签样式 - 不在 pre 内的code */
/deep/ :not(pre) > code {
  font-size: .875em;
  font-weight: 600;
  background-color: #ececec;
  border-radius: 4px;
  padding: .15rem .3rem;
  margin: 0 .2rem;
}

/* pre 内的 code 标签样式 */
/deep/ pre > code {
  font-size: .875em;
  background-color: transparent;
  padding: 0;
  border-radius: 0;
  font-family: monospace;
  font-weight: normal;
  color: #333;
  display: block;
  width: 100%;
}

/deep/ a {
  color: #4d6bfe;
  text-decoration: none;
}

/deep/ a:hover {
  text-decoration: underline;
}

/deep/ blockquote {
  border-left: 4px solid #e5e5e5;
  padding-left: 1em;
  margin: 1em 0;
  color: #666;
}

/deep/ table {
  border-collapse: collapse;
  width: 100%;
  margin: 1em 0;
  font-size: 0.95em;
}

/deep/ th, /deep/ td {
  border: 1px solid #e5e5e5;
  padding: 0.6em;
  text-align: left;
}

/deep/ th {
  background-color: #f5f5f5;
}

/deep/ hr {
  background-color: rgb(229 229 229);
  margin: 1.5em 0;
  height: 1px;
  border: none;
}

/* 确保相邻元素之间的间距一致且适当 */
/deep/ h1 + p,
/deep/ h2 + p,
/deep/ h3 + p {
  margin-top: 0.5em;
}

/deep/ p + ul,
/deep/ p + ol {
  margin-top: 0.5em;
}

/deep/ ul + p,
/deep/ ol + p {
  margin-top: 0.7em;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/StreamMDRender.vue